import { dayjs } from '../dayjs';

export interface DayRange {
  startedAt: Date | null;
  endedAt: Date | null;
}

/**
 * Normalize a selected date range to full-day boundaries.
 *
 * The start is snapped to the beginning of its day (00:00:00.000) and the end
 * to the end of its day (23:59:59.999). Date pickers hand back a raw datetime
 * (often 00:00), so passing the end date straight to a query drops any record
 * created later on that final day. Normalizing here keeps a report's search and
 * export in agreement and inclusive of the entire range.
 *
 * @param start Selected start date, or null/undefined when unset
 * @param end Selected end date, or null/undefined when unset
 * @returns `startedAt` at the start of the start day and `endedAt` at the end of
 *   the end day; each is null when the corresponding input is null/undefined
 */
export function toDayRange(start: Date | null | undefined, end: Date | null | undefined): DayRange {
  return {
    startedAt: start ? dayjs(start).startOf('day').toDate() : null,
    endedAt: end ? dayjs(end).endOf('day').toDate() : null,
  };
}
